import _ from "lodash";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { isValidElement, useEffect, useState } from "react";
import { graphql, compose } from "lib/apolloClient";
import { connect } from "react-redux";
import I18nHOC from "UIComponents/I18nHOC";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import withDerivedProps from "lib/withDerivedProps";
import {
  Button,
  Tooltip,
  Modal,
  Checkbox,
  IconButton,
  Dropdown,
  DropdownMenu,
} from "@toddle-edu/ds-web";
import { SettingsOutlined } from "@toddle-edu/ds-icons";
import { getOrganizationAcademicYearsQuery } from "SchoolSetup/routes/AcademicYearTerms/modules/Query";
import { getOrganizationPointSetQuery } from "ScoreCategories/modules/ScoreCategoriesQueries";
import { getCourseDetailsQuery } from "ProgressSummary/modules/ProgressSummaryQuery";
import { getOrganizationAcademicYearsFromCache } from "SchoolSetup/routes/AcademicYearTerms/modules/GraphqlHelpers";
import {
  getOrganizationPointSetFromCache,
  getOrganizationPointSet,
} from "ScoreCategories/modules/ScoreCategoriesGraphqlHelpers";
import { getCourseDetailsFromCache } from "ProgressSummary/modules/ProgressSummaryGraphqlHelpers";
import { getCourseDetailsFromCache as getCourseDetails } from "Course/modules/CourseGraphqlHelpers";
import {
  checkCategorySetApplicableTo,
  getAssessmentCategorySetStructure,
} from "ScoreCategories/modules/ScoreCategoriesModule";
import {
  getIsConfigurationEnabledForCPAY,
  getSettingValue,
} from "modules/PermissionModule";
import { getCurrentTerm, onEnterOrSpaceKeyDown } from "Utils";
import {
  getDropdownItemsMemoize,
  getSelectedSubjectIdMemoize,
  getUnitPlanRelatedData,
  getAssociatedEntitiesVariables,
} from "../MaxScoreTool/Utils";
import {
  getNextUnlockedTerm,
  getOrganizationPointSetByAcademicTermId,
  getOrganizationPointSetData,
  getTermOption,
  getDisabledCategoryDropdownTooltip,
  getCommonCategoriesFromGradingSetup,
  getCategoryInputForUpdateAssessment,
  getCategoryObj,
} from "./utils";
import classes from "./AssessmentCategory.scss";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import {
  updateAssessment,
  removeAssessmentTool,
} from "Assessments/modules/AssessmentModule";
import {
  getIsScoreV2,
  getGradeCalculationWeightageTypeSetting,
  getGradeCalculationMethodCategory,
} from "routes/routes/Administrator/routes/DPAcademicSetup/routes/AssessmentSetup/modules/utils";
import {
  ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
  COURSE_BASED_GRADING,
  CURRICULUM_TYPE_UBD,
  GRADE_SCALE_TOOL,
  SCORE_BASED,
  SUBJECT_BASED_GRADING,
  TODDLE_LIBRARY,
} from "Constants/stringConstants";
import { Trans } from "react-i18next";
import update from "immutability-helper";
import { getAssessmentDetailsFromCache } from "Assessments/modules/AssessmentGraphqlHelpers";
import { getAdminSetupFiltersByEntityTypeMemoized } from "Administrator/modules/Utils";
import SubjectCategory from "MYPAcademicSetup/routes/ScoreCategories/routes/SubjectCategory/components";
import {
  getCurrentCurriculumProgramType,
  getSelectedAcademicYearId,
  getCurrentAcademicYear,
} from "modules/CommonSelectors";
import {
  getSubjectLevelGenericTagsFromFlatVariants,
  getScoreCategoriesStateWithUpdatedTemplateFieldsForEditing,
  getScoreCategoriesInitialState,
} from "ScoreCategories/modules/Utils";
import {
  getIsNewAssessmentSettingsEnabled,
  getSubjectsWithNoGradebook,
  USE_WEIGHTAGE_FOR_CATEGORY_SETTING,
  CATEGORY_FINAL_SCORE_DISPLAY_TYPE_SETTING,
} from "GradingSetup/modules/Utils";
import { getCategoriesWithPercentageValues } from "Gradebook/modules/Utils";
import classNames from "classnames";

import ACLStorage from "lib/aclService";
import {
  MANAGE_ASSESSMENT_CATEGORY_PERMISSION,
  USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
} from "Constants/permissionConstants";
import withControlParameters from "lib/aclService/hoc/withControlParameters";
import {
  getAcademicSetupTypeIfLearningCoursesEnabled,
  getIsCourseBasedGradingEnabled,
  getIsLearningCoursesEnabled,
} from "LearningCourses/modules/Utils";
import { WithConfigurationsAndPreferences } from "Utils/ConfigurationUtils/hoc";
import { generateConfigurationQueryVariablesV2 } from "Utils/ConfigurationUtils/Utils";
import { getAssessmentLearningCourseDetailsQuery } from "Assessments/modules/AssessmentQuery";
import {
  getCourseGradingSettingsAndCategorySetsQuery,
  getMultiSubjectGradingSettingsAndCategorySetsQuery,
} from "GradingConfigurations/modules/GradingConfigurationQueries";
import { getLearningCourseDetailsFromCache } from "Teacher/routes/LearningCourse/modules/LearningCourseGraphqlHelpers";
import { getLearningCourseVariables } from "Teacher/routes/LearningCourse/modules/Utils";

/*

Assessment has Auto IB grade tool with category grade boundary

1. change category
  a. has boundary -> show HAS_CATEGORY_BOUNDARY
  b. no boundary -> show NO_CATEGORY_BOUNDARY

2. change term
  a. category reset -> show RESET_TOOL_WITH_TERM

Assessment has Auto IB grade tool with Term grade boundary

1. change term
  a. has boundary -> show HAS_TERM_BOUNDARY
  b. no boundary -> show RESET_TOOL_WITH_TERM

2. change category
  a. category reset -> no impact

*/

// Helper functions for dialog checkbox interactions
const createDialogHandlers = setCurrentDialogueInfo => {
  const handleToggleCheckbox = () => {
    setCurrentDialogueInfo(prevState => {
      return {
        ...prevState,
        params: {
          ...(prevState?.params || {}),
          isChecked: !_.get(prevState, "params.isChecked", false),
        },
      };
    });
  };

  const handleCheckboxKeyDown = event => {
    onEnterOrSpaceKeyDown(event, handleToggleCheckbox);
  };

  return { handleToggleCheckbox, handleCheckboxKeyDown };
};

const DIALOGS_INFO = {
  HAS_CATEGORY_BOUNDARY: {
    title: ({ t, currentDialogueInfo }) =>
      t(`classRoom:change_category_to_label`, {
        label: _.get(currentDialogueInfo, "params.newLabel"),
      }),
    body: ({ currentDialogueInfo }) => {
      const { newLabel = "", currentLabel = "" } =
        _.get(currentDialogueInfo, "params", {}) || {};

      return (
        <Trans i18nKey="classRoom:category_with_grade_boundary_msg">
          <span className={classes.modalMediumLabel}>
            Changing the category for this task will also update the category
            grade boundary used in the ‘IB grade’ assessment tool.
          </span>

          <span className={classes.modalDemiBoldLabel}>Category</span>
          <span className={classes.modalMediumLabel}>
            {{ currentLabel }} {{ newLabel }}
          </span>
          <span className={classes.modalDemiBoldLabel}>
            Category grade boundary used in IB grade assessment tool
          </span>
          <span>
            {{ currentLabel }} {{ newLabel }}
          </span>
        </Trans>
      );
    },
    confirmButtonText: ({ t }) => t("common:change"),
    cancelButtonText: ({ t }) => t("common:cancel"),
    width: () => "472px",
  },

  HAS_TERM_BOUNDARY: {
    title: ({ t, currentDialogueInfo }) =>
      t(`classRoom:change_term_to_label`, {
        label: _.get(currentDialogueInfo, "params.newLabel"),
      }),
    body: ({ currentDialogueInfo }) => {
      const { newLabel = "", currentLabel = "" } =
        _.get(currentDialogueInfo, "params", {}) || {};

      return (
        <Trans i18nKey="classRoom:term_with_grade_boundary_msg">
          <span className={classes.modalMediumLabel}>
            Changing the term for this task will also update the category grade
            boundary used in the ‘IB grade’ assessment tool.
          </span>

          <span className={classes.modalDemiBoldLabel}>Term</span>
          <span className={classes.modalMediumLabel}>
            {{ currentLabel }} {{ newLabel }}
          </span>
          <span className={classes.modalDemiBoldLabel}>
            Term grade boundary used in IB grade assessment tool
          </span>
          <span>
            {{ currentLabel }} {{ newLabel }}
          </span>
        </Trans>
      );
    },
    confirmButtonText: ({ t }) => t("common:change"),
    cancelButtonText: ({ t }) => t("common:cancel"),
    width: () => "472px",
  },

  DESELECT_PREV_TERM: {
    title: ({ t, currentDialogueInfo }) =>
      t(`classRoom:deselect_term_with_label`, {
        label: _.get(currentDialogueInfo, "params.selectedTermLabel"),
      }),
    body: ({ t, currentDialogueInfo }) =>
      t(`classRoom:deselect_term_subtext_with_label`, {
        label: _.get(currentDialogueInfo, "params.selectedTermLabel"),
      }),

    confirmButtonText: ({ t, termLabel }) =>
      t("common:deselect_with_label", { label: termLabel || t("common:term") }),
    cancelButtonText: ({ t }) => t("common:cancel"),
    width: () => "440px",
  },

  NO_CATEGORY_BOUNDARY: {
    title: ({ t, currentDialogueInfo }) =>
      t(`classRoom:change_category_to_label`, {
        label: _.get(currentDialogueInfo, "params.newLabel"),
      }),
    body: ({ t, currentDialogueInfo, setCurrentDialogueInfo }) => {
      const { newLabel = "", currentLabel = "", isChecked = false } =
        _.get(currentDialogueInfo, "params", {}) || {};

      const {
        handleToggleCheckbox,
        handleCheckboxKeyDown,
      } = createDialogHandlers(setCurrentDialogueInfo);

      return (
        <div className={classes.modalBodyContainer}>
          <div className={classes.modalBodyUpperInnerContainer}>
            <Trans i18nKey="classRoom:category_without_grade_boundary_msg">
              <span>Changing the category for this task</span>
              <span className={classes.modalBoldLabel}>
                will remove the ‘IB grade’ assessment tool
              </span>
              <span className={classes.modalMediumLabel}>
                from this task. You can always add it back later.
              </span>
              <span className={classes.modalDemiBoldLabel}>Category</span>
              <span className={classes.modalMediumLabel}>
                {{ currentLabel }} {{ newLabel }}
              </span>
              <span className={classes.modalDemiBoldLabel}>
                Category grade boundary used in IB grade assessment tool
              </span>
              <span>{{ currentLabel }} </span>
              <span className={classes.modalDisabledLabel}>
                No grade boundary found
              </span>
            </Trans>
          </div>

          <div
            className={classes.modalBodyBottomInnerContainer}
            onClick={handleToggleCheckbox}
            onKeyDown={handleCheckboxKeyDown}
            tabIndex={0}
            role="button"
            aria-label={t("classRoom:ib_grade_scale_tool_remove_warning")}
          >
            <Checkbox isChecked={isChecked} />
            {t("classRoom:ib_grade_scale_tool_remove_warning")}
          </div>
        </div>
      );
    },
    confirmButtonText: ({ t }) => t("common:change"),
    cancelButtonText: ({ t }) => t("common:cancel"),
    width: () => "472px",
    disableConfirmButton: ({ currentDialogueInfo }) =>
      !_.get(currentDialogueInfo, "params.isChecked", false),
  },

  RESET_TOOL_WITH_TERM: {
    title: ({ t, currentDialogueInfo }) =>
      t(`classRoom:change_term_to_label`, {
        label: _.get(currentDialogueInfo, "params.newLabel"),
      }),
    body: ({ t, currentDialogueInfo, setCurrentDialogueInfo }) => {
      const {
        newLabel = "",
        currentLabel = "",
        currentCategoryLabel = "",
        isChecked = false,
      } = _.get(currentDialogueInfo, "params", {}) || {};

      const {
        handleToggleCheckbox,
        handleCheckboxKeyDown,
      } = createDialogHandlers(setCurrentDialogueInfo);

      return (
        <div className={classes.modalBodyContainer}>
          <div className={classes.modalBodyUpperInnerContainer}>
            <Trans i18nKey="classRoom:term_change_with_category_grade_boundary_msg">
              <span>Changing the term for this task</span>
              <span className={classes.modalBoldLabel}>
                will remove the ‘IB grade’ assessment tool
              </span>
              <span className={classes.modalMediumLabel}>
                from this task. You can always add it back later.
              </span>
              <span className={classes.modalDemiBoldLabel}>Term</span>
              <span className={classes.modalMediumLabel}>
                {{ currentLabel }} {{ newLabel }}
              </span>
              <span className={classes.modalDemiBoldLabel}>
                Category grade boundary used in IB grade assessment tool
              </span>
              <span>{{ currentCategoryLabel }} </span>
              <span className={classes.modalDisabledLabel}>
                No grade boundary found
              </span>
            </Trans>
          </div>

          <div
            className={classes.modalBodyBottomInnerContainer}
            onClick={handleToggleCheckbox}
            onKeyDown={handleCheckboxKeyDown}
            tabIndex={0}
            role="button"
            aria-label={t("classRoom:ib_grade_scale_tool_remove_warning")}
          >
            <Checkbox isChecked={isChecked} />
            {t("classRoom:ib_grade_scale_tool_remove_warning")}
          </div>
        </div>
      );
    },
    confirmButtonText: ({ t }) => t("common:change"),
    cancelButtonText: ({ t }) => t("common:cancel"),
    width: () => "472px",
    disableConfirmButton: ({ currentDialogueInfo }) =>
      !_.get(currentDialogueInfo, "params.isChecked", false),
  },

  NO_TERM_BOUNDARY: {
    title: ({ t, currentDialogueInfo }) =>
      t(`classRoom:change_term_to_label`, {
        label: _.get(currentDialogueInfo, "params.newLabel"),
      }),
    body: ({ t, currentDialogueInfo, setCurrentDialogueInfo }) => {
      const {
        newLabel = "",
        currentLabel = "",
        currentCategoryLabel = "",
        isChecked = false,
      } = _.get(currentDialogueInfo, "params", {}) || {};

      const {
        handleToggleCheckbox,
        handleCheckboxKeyDown,
      } = createDialogHandlers(setCurrentDialogueInfo);

      return (
        <div className={classes.modalBodyContainer}>
          <div className={classes.modalBodyUpperInnerContainer}>
            <Trans i18nKey="classRoom:term_without_grade_boundary_msg">
              <span>Changing the term for this task</span>
              <span className={classes.modalBoldLabel}>
                will remove the ‘IB grade’ assessment tool
              </span>
              <span className={classes.modalMediumLabel}>
                from this task. You can always add it back later.
              </span>
              <span className={classes.modalDemiBoldLabel}>Term</span>
              <span className={classes.modalMediumLabel}>
                {{ currentLabel }} {{ newLabel }}
              </span>
              <span className={classes.modalDemiBoldLabel}>
                Category grade boundary used in IB grade assessment tool
              </span>
              <span>{{ currentCategoryLabel }} </span>
              <span className={classes.modalDisabledLabel}>
                No grade boundary found
              </span>
            </Trans>
          </div>

          <div
            className={classes.modalBodyBottomInnerContainer}
            onClick={handleToggleCheckbox}
            onKeyDown={handleCheckboxKeyDown}
            tabIndex={0}
            role="button"
            aria-label={t("classRoom:ib_grade_scale_tool_remove_warning")}
          >
            <Checkbox isChecked={isChecked} />
            {t("classRoom:ib_grade_scale_tool_remove_warning")}
          </div>
        </div>
      );
    },
    confirmButtonText: ({ t }) => t("common:change"),
    cancelButtonText: ({ t }) => t("common:cancel"),
    width: () => "472px",
    disableConfirmButton: ({ currentDialogueInfo }) =>
      !_.get(currentDialogueInfo, "params.isChecked", false),
  },

  REMOVE_GRADE_SCALE_TOOL: {
    title: ({ t, currentDialogueInfo }) =>
      t(`classRoom:change_term_to_label`, {
        label: _.get(currentDialogueInfo, "params.newLabel"),
      }),
    body: ({ t, currentDialogueInfo, setCurrentDialogueInfo }) => {
      const { isChecked = false } =
        _.get(currentDialogueInfo, "params", {}) || {};

      const {
        handleToggleCheckbox,
        handleCheckboxKeyDown,
      } = createDialogHandlers(setCurrentDialogueInfo);

      return (
        <div className={classes.modalBodyContainer}>
          <div className={classes.modalBodyUpperInnerContainer}>
            <Trans i18nKey="classRoom:term_change_with_grade_scale_tool_msg">
              <span>Changing the term for this task</span>
              <span className={classes.modalBoldLabel}>
                will remove the &apos;Grade scale&apos; assessment tool
              </span>
              <span className={classes.modalMediumLabel}>
                from this task. You can always add it back later.
              </span>
            </Trans>
          </div>

          <div
            className={classes.modalBodyBottomInnerContainer}
            onClick={handleToggleCheckbox}
            onKeyDown={handleCheckboxKeyDown}
            tabIndex={0}
            role="button"
            aria-label={t("classRoom:grade_scale_tool_remove_warning")}
          >
            <Checkbox isChecked={isChecked} />
            {t("classRoom:grade_scale_tool_remove_warning")}
          </div>
        </div>
      );
    },
    confirmButtonText: ({ t }) => t("common:change"),
    cancelButtonText: ({ t }) => t("common:cancel"),
    width: () => "472px",
    disableConfirmButton: ({ currentDialogueInfo }) =>
      !_.get(currentDialogueInfo, "params.isChecked", false),
  },
};

const styles = {
  childrenContainerStyle: {
    height: "100%",
  },
  labelContainerStyle: {
    width: "240px",
    justifyContent: "center",
  },
};

const getTermDropdownLabel = ({
  t,
  termLabel,
  isUsingNewGradingSetupInCourses,
}) => {
  return (
    termLabel ||
    (isUsingNewGradingSetupInCourses
      ? t("common:grading_period")
      : t("common:term"))
  );
};

const AssessmentCategory = React.memo(props => {
  const {
    t,
    terms,
    organizationPointSet,
    dependentFieldValue,
    isScoreV2,
    updateAssessment,
    removeAssessmentTool,
    academicTermId,
    category,
    weightageType,
    assessmentFields = [],
    isTOK,
    selectedSubjectId,
    termPointSetVariables,
    autoIBGradeTool,
    gradeScaleTool,
    gradeId,
    courseId,
    previousAcademicYearTermSelected,
    curriculumType,
    curriculumProgramId,
    organizationId,
    isCourseApplicableToCategorySet,
    variables,
    getOrganizationPointSetRefetch,
    isEditingAllowed,
    subject,
    subjectId,
    subjectName,
    assessmentId,
    assessmentCategoryId,
    scoreBasedAssessmentVariables,
    rootNodes,
    gradeName,
    labelComponent,
    isEditMode,
    isNewAssessmentSettingsEnabled,
    defaultGradeScaleSet,
    portalType,
    customRef,
    testId = "IBComponents-assessmentCategory",
    field_list,
    isUsingNewGradingSetupInCourses,
    isCourseBasedGradingEnabled,
    learningCourseGradingConfig,
    multiSubjectGradingConfig,
    isCategoryWeightageEnabled,
    categoryTotalDisplayType,
    // New props for controlling component behavior for categories
    showCategoriesOnly = false,
    hideConfigureCategoriesButton = false,
    categoryTriggerElement = null,
    shouldHideCategoryLabel = false,
    categoryDropdownMenuProps = {},
    showToast = false,
  } = props;

  const fieldObj = _.get(field_list, "assessmentCategory", {});
  const config = _.get(fieldObj, "config", {});
  const termLabel = _.get(config, "termLabel");
  const categoryLabel = _.get(config, "categoryLabel", t("common:category"));

  const termDropdownLabel = getTermDropdownLabel({
    t,
    termLabel,
    isUsingNewGradingSetupInCourses,
  });

  const subjectLevels = _.get(
    _.find(assessmentFields, field => {
      return _.get(field, "uid") === "subjectLevel";
    }),
    "value",
    []
  );

  const subjectsField = _.find(assessmentFields, field => {
    return _.get(field, "uid") === "subjects";
  });

  const [classSettingMode, setClassSettingMode] = useState({
    isEditing: false,
    assessmentCategoryId: "",
  });
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [currentDialogueInfo, setCurrentDialogueInfo] = useState({
    action: "",
    params: {},
  });
  const [
    showConfigureCategoriesModal,
    setShowConfigureCategoriesModal,
  ] = useState(false);
  const [stateForScoreCategories, setStateForScoreCategories] = useState({});
  const [isError, setIsError] = useState(false);

  const closeConfigureCategoriesModalOnSave = () => {
    setShowConfigureCategoriesModal(false);
    getOrganizationPointSetRefetch();
  };

  const isAbsoluteWeightageType = _.isEqual(weightageType, "ABSOLUTE");

  const debouncedUpdateAssessment = React.useMemo(
    () => _.debounce(updateAssessment, 500),
    []
  );

  const termsOptions = _.map(terms, term => getTermOption(term, t));
  const currentTerm = getTermOption(getCurrentTerm({ terms }), t);

  const filteredOrganizationPointSet = isScoreV2
    ? getOrganizationPointSetByAcademicTermId({
        organizationPointSet,
        termId: _.get(selectedTerm, "value"),
      })
    : getOrganizationPointSetData({ organizationPointSet });

  const orderedCategories = _.orderBy(
    _.get(filteredOrganizationPointSet, "categories", []),
    "displaySequence",
    "asc"
  );

  const flatVariants = _.get(subject, "flatVariants", []);
  const subjectLevelGenericTags = getSubjectLevelGenericTagsFromFlatVariants({
    flatVariants,
  });

  const categories = getCategoriesWithPercentageValues({
    categories: isUsingNewGradingSetupInCourses
      ? getCommonCategoriesFromGradingSetup({
          gradingConfigurations: isCourseBasedGradingEnabled
            ? _.castArray(learningCourseGradingConfig)
            : multiSubjectGradingConfig,
          selectedGradingPeriodId: _.get(selectedTerm, "value"),
          curriculumProgramId,
          category,
        })
      : orderedCategories,
    subjectLevelGenericTags,
    categoryValuePath: "values",
  });

  const categoryDropdownItems = getDropdownItemsMemoize({
    categories,
    subjectLevels,
    isTOK,
    isAbsoluteWeightageType,
    t,
    isNewAssessmentSettingsEnabled,
    isCategoryWeightageEnabled,
    categoryTotalDisplayType,
  });

  const categoriesOptions = _.map(categoryDropdownItems, item => {
    return {
      key: item.key,
      value: item.key,
      label: item.label,
      subtitle: item.subtitle,
      subText: item.subtitle,
    };
  });

  const showCategoryDropdown = isScoreV2 || _.size(categoriesOptions) > 1;

  const showTermsDropdown = !showCategoriesOnly && _.size(termsOptions) > 0;

  useEffect(() => {
    if (!_.isEmpty(termsOptions) && !selectedTerm) {
      if (_.isEmpty(academicTermId) && isEditMode) {
        const currentSelectedTerm = !_.get(
          currentTerm,
          "isGradingPeriodUnlocked",
          true
        )
          ? getNextUnlockedTerm({
              termsOptions,
              selectedTerm: currentTerm,
            })
          : currentTerm;
        const academicTermId = _.get(currentSelectedTerm, "value", "");
        setSelectedTerm(currentSelectedTerm);
        debouncedUpdateAssessment({
          hasFields: false,
          academicTermId,
          courseId:
            !_.isEmpty(autoIBGradeTool) && courseId ? courseId : undefined,
        });
      } else {
        const currentSelectedTerm = _.find(termsOptions, term =>
          _.isEqual(_.get(term, "value", ""), academicTermId)
        );

        const isCurrentSelectedTermUnlocked = _.get(
          currentSelectedTerm,
          "isGradingPeriodUnlocked",
          true
        );

        const termToSelect =
          !isCurrentSelectedTermUnlocked && isEditMode
            ? getNextUnlockedTerm({
                termsOptions,
                selectedTerm: currentSelectedTerm,
              })
            : currentSelectedTerm;

        setSelectedTerm(termToSelect);

        if (!isCurrentSelectedTermUnlocked && isEditMode) {
          debouncedUpdateAssessment({
            hasFields: false,
            academicTermId: _.get(termToSelect, "key"),
            courseId:
              !_.isEmpty(autoIBGradeTool) && courseId ? courseId : undefined,
          });
        }
      }
    }
  }, [termsOptions]);

  useEffect(() => {
    // reset category when ->
    // 1. more than 1 associated subjects are selected
    // 2. user dis-selects assoicated subjects after selecting category (dependentFieldValue becomes empty)
    const shouldResetCategory =
      !isUsingNewGradingSetupInCourses &&
      !isCourseBasedGradingEnabled &&
      !_.isEmpty(category) &&
      (_.isEmpty(dependentFieldValue) || _.size(dependentFieldValue) > 1);

    if (shouldResetCategory && isEditMode) {
      const categoryInput = getCategoryInputForUpdateAssessment({
        updatedCategoryId: null,
        currentCategoryId: selectedCategory?.value,
        isUsingNewGradingSetupInCourses,
      });

      debouncedUpdateAssessment({ hasFields: false, ...categoryInput });
      setSelectedCategory(null);
    }
  }, [dependentFieldValue, category]);

  useEffect(() => {
    if (
      selectedSubjectId &&
      _.size(categoriesOptions) === 1 &&
      selectedCategory &&
      isEditMode
    ) {
      setSelectedCategory(null);

      const categoryInput = getCategoryInputForUpdateAssessment({
        updatedCategoryId: null,
        currentCategoryId: selectedCategory?.value,
        isUsingNewGradingSetupInCourses,
      });

      updateAssessment({
        hasFields: false,
        ...categoryInput,
        courseId:
          !_.isEmpty(autoIBGradeTool) && courseId ? courseId : undefined,
      });
    } else if (!_.isEmpty(category?.id) && !selectedCategory) {
      setSelectedCategory(
        _.find(categoriesOptions, option =>
          _.isEqual(_.get(option, "value", ""), category?.id)
        ) || null
      );
    }
  }, [categoriesOptions, category]);

  const disableCategoriesDropdown =
    _.size(categoriesOptions) <= 1 || !isEditMode;

  const updateTerm = async term => {
    // do not update if clicked on same term again
    if (term?.value === selectedTerm?.value) return;

    if (await shouldUpdateAssessment({ term })) {
      setSelectedTerm(term);
      const academicTermId = _.get(term, "value", "");

      const categoryInput = getCategoryInputForUpdateAssessment({
        updatedCategoryId: null, // reset category on term change
        currentCategoryId: selectedCategory?.value,
        isUsingNewGradingSetupInCourses,
      });

      debouncedUpdateAssessment({
        hasFields: false,
        academicTermId,
        courseId:
          !_.isEmpty(autoIBGradeTool) && courseId ? courseId : undefined,
        ...categoryInput,
      });

      if (isScoreV2) {
        setSelectedCategory(null);
      }

      if (isError) {
        setIsError(false);
      }
    }
  };

  const shouldUpdateAssessment = async ({ category: newCategory, term }) => {
    // on dialog box confirm button click, update the assessment
    if (currentDialogueInfo?.action) return true;

    if (!_.isEmpty(autoIBGradeTool)) {
      const assessmentToolType = _.get(
        autoIBGradeTool,
        "node.assessmentToolType"
      );

      const toolHasCategoryBoundary =
        assessmentToolType === ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY;

      // if user changes category and tool does not have category boundary
      // then let user change it
      if (!toolHasCategoryBoundary && newCategory) return true;

      // if user changes term and tool has category boundary
      // then show dialog box to delete tool
      if (toolHasCategoryBoundary && term) {
        const newTerm = _.find(terms, ({ id }) => term?.value === id);
        const currentTerm = _.find(
          terms,
          ({ id }) => selectedTerm?.value === id
        );

        setCurrentDialogueInfo({
          action: "RESET_TOOL_WITH_TERM",
          params: {
            newTerm: term,
            newLabel: newTerm?.label,
            currentLabel: currentTerm?.label,
            isChecked: false,
            assessmentToolId: _.get(autoIBGradeTool, "node.id"),
            assessmentToolType: _.get(
              autoIBGradeTool,
              "node.assessmentToolType"
            ),
            currentCategoryLabel: category?.label,
          },
        });

        return false;
      }

      switch (assessmentToolType) {
        case ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY: {
          const hasGradeBoundary = !_.isEmpty(
            _.find(categories, cat => cat?.id === newCategory?.value)
              ?.gradeBoundary
          );

          if (hasGradeBoundary) {
            setCurrentDialogueInfo({
              action: "HAS_CATEGORY_BOUNDARY",
              params: {
                newCategory,
                newLabel: newCategory?.label,
                currentLabel: category?.label,
              },
            });
            return false;
          } else {
            setCurrentDialogueInfo({
              action: "NO_CATEGORY_BOUNDARY",
              params: {
                newCategory,
                newLabel: newCategory?.label,
                currentLabel: category?.label,
                isChecked: false,
              },
            });
            return false;
          }
        }
        case ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY: {
          const variables = update(termPointSetVariables, {
            filters: {
              associatedEntites: {
                $push: [
                  {
                    type: "ACADEMIC_TERM",
                    ids: _.get(term, "value"),
                  },
                  {
                    type: "GRADE",
                    ids: gradeId,
                  },
                ],
              },
            },
          });

          const termPointSetData = await getOrganizationPointSet({ variables });

          const termGradeBoundaryCategories = _.get(
            termPointSetData,
            "pointAssessmentSets.edges.0.node.categories",
            []
          );

          if (!_.isEmpty(termGradeBoundaryCategories)) {
            const newTerm = _.find(terms, ({ id }) => term?.value === id);
            const currentTerm = _.find(
              terms,
              ({ id }) => selectedTerm?.value === id
            );

            setCurrentDialogueInfo({
              action: "HAS_TERM_BOUNDARY",
              params: {
                newTerm: term,
                newLabel: newTerm?.label,
                currentLabel: currentTerm?.label,
              },
            });
            return false;
          } else {
            const newTerm = _.find(terms, ({ id }) => term?.value === id);
            const currentTerm = _.find(
              terms,
              ({ id }) => selectedTerm?.value === id
            );

            setCurrentDialogueInfo({
              action: "NO_TERM_BOUNDARY",
              params: {
                newTerm: term,
                newLabel: newTerm?.label,
                currentLabel: currentTerm?.label,
                isChecked: false,
                currentCategoryLabel: category?.label,
              },
            });

            return false;
          }
        }
        default:
          return true;
      }
    }

    // Check for GRADE_SCALE_TOOL when term changes
    if (!_.isEmpty(gradeScaleTool) && term) {
      const newTerm = _.find(terms, ({ id }) => term?.value === id);
      const currentTerm = _.find(terms, ({ id }) => selectedTerm?.value === id);

      setCurrentDialogueInfo({
        action: "REMOVE_GRADE_SCALE_TOOL",
        params: {
          newTerm: term,
          newLabel: newTerm?.label,
          currentLabel: currentTerm?.label,
          isChecked: false,
          assessmentToolId: _.get(gradeScaleTool, "node.assessmentToolItem.id"),
          assessmentToolType: _.get(gradeScaleTool, "node.assessmentToolType"),
        },
      });

      return false;
    }

    return true;
  };

  const updateCategory = async category => {
    // do not update if clicked on same category again
    if (category?.value === selectedCategory?.value) return;

    if (await shouldUpdateAssessment({ category })) {
      let toastMsg = "";
      if (_.isEqual(category.value, -1)) {
        const categoryInput = getCategoryInputForUpdateAssessment({
          updatedCategoryId: null,
          currentCategoryId: selectedCategory?.value,
          isUsingNewGradingSetupInCourses,
        });

        if (showToast) {
          toastMsg = t("toastMsgs:category_successfully_updated");
        }

        debouncedUpdateAssessment({
          hasFields: false,
          ...categoryInput,
          courseId:
            !_.isEmpty(autoIBGradeTool) && courseId ? courseId : undefined,
          assessmentId,
          toastMsg,
        });
      } else {
        const categoryId = _.get(category, "value");

        const categoryInput = getCategoryInputForUpdateAssessment({
          updatedCategoryId: categoryId,
          currentCategoryId: selectedCategory?.value,
          isUsingNewGradingSetupInCourses,
        });

        if (showToast) {
          toastMsg = t("toastMsgs:category_updated_to", {
            categoryName: _.get(category, "label", ""),
          });
        }

        debouncedUpdateAssessment({
          hasFields: false,
          ...categoryInput,
          courseId:
            !_.isEmpty(autoIBGradeTool) && courseId ? courseId : undefined,
          assessmentId,
          toastMsg,
        });
      }
      setSelectedCategory(category);
    }
  };

  const editAssessmentCategoryModalTitle = disableCategoriesDropdown
    ? t("schoolSetup:assessment_categories_edit_modal_text", {
        term: _.get(selectedTerm, "label", ""),
        subject: subjectName,
      })
    : t("schoolSetup:edit_assessment_category_set_with_subject_and_term_name", {
        term: _.get(selectedTerm, "label", ""),
        subject: subjectName,
      });

  const associatedEntities = [
    ..._.get(variables, "filters.associatedEntites", []),
  ];
  if (isScoreV2) {
    associatedEntities.push({
      type: "ACADEMIC_TERM",
      ids: _.get(selectedTerm, "value"),
    });
  }
  const pointSetVariables = {
    id: organizationId,
    filters: {
      ..._.get(variables, "filters", {}),
      associatedEntites: associatedEntities,
    },
    portalType,
  };
  const selectedGrade = {
    key: gradeId,
    value: gradeId,
    label: gradeName,
  };

  const handleShowModal = () => {
    let scoreCategoriesInitialState;
    if (disableCategoriesDropdown) {
      scoreCategoriesInitialState = getScoreCategoriesInitialState();
    } else {
      const set = getAssessmentCategorySetStructure({
        scoreCategorySet: filteredOrganizationPointSet,
        isCourseApplicableToCategorySet,
      });
      scoreCategoriesInitialState = getScoreCategoriesStateWithUpdatedTemplateFieldsForEditing(
        { set }
      );
    }
    setStateForScoreCategories(scoreCategoriesInitialState);
    setShowConfigureCategoriesModal(true);
  };

  const onClickConfirm = async () => {
    setShowLoader(true);

    switch (currentDialogueInfo?.action) {
      case "HAS_CATEGORY_BOUNDARY":
      case "NO_CATEGORY_BOUNDARY": {
        const newCategory = _.get(
          currentDialogueInfo,
          "params.newCategory",
          {}
        );

        await updateCategory(newCategory);
        break;
      }
      case "HAS_TERM_BOUNDARY":
      case "NO_TERM_BOUNDARY":
      case "RESET_TOOL_WITH_TERM": {
        const newTerm = _.get(currentDialogueInfo, "params.newTerm", {});
        await updateTerm(newTerm);
        break;
      }
      case "REMOVE_GRADE_SCALE_TOOL": {
        const assessmentToolId = _.get(
          currentDialogueInfo,
          "params.assessmentToolId"
        );
        const assessmentToolType = _.get(
          currentDialogueInfo,
          "params.assessmentToolType"
        );

        // Remove the grade scale tool
        await removeAssessmentTool({
          id: assessmentToolId,
          type: assessmentToolType,
          parentId: assessmentId,
          parentType: "ASSESSMENT",
          portalType,
        });

        const newTerm = _.get(currentDialogueInfo, "params.newTerm", {});
        await updateTerm(newTerm);
        break;
      }
      case "DESELECT_PREV_TERM": {
        const newTerm = _.get(currentDialogueInfo, "params.newTerm", {});
        await updateTerm(newTerm);
        break;
      }
    }

    setShowLoader(false);
    setCurrentDialogueInfo({});
  };

  const onChangeTerm = term => {
    if (previousAcademicYearTermSelected) {
      const selectedTermLabel = _.get(
        _.find(
          terms,
          term => _.get(term, "id") === _.get(selectedTerm, "value")
        ),
        "label"
      );
      setCurrentDialogueInfo({
        action: "DESELECT_PREV_TERM",
        params: { newTerm: term, selectedTermLabel },
      });
    } else {
      updateTerm(term);
    }
  };

  const isValid = () => {
    // If terms don't exist then allow the user to create the assessment without a selected term, as this should only be possible from the unit plan.
    // They can't assign the assessment to students until they create terms, and during assignment BE handles selecting a default term.
    // A check for unit plan specifically wasn't added since it should only be possible to get to this point from there,
    // everywhere else assignment creation itself is disabled unless terms have been configured.
    if (!_.isEmpty(termsOptions) && _.isEmpty(selectedTerm)) {
      setIsError(true);
      return 1;
    }

    if (isError) {
      setIsError(false);
    }

    return 0;
  };

  if (customRef) {
    customRef({
      isValid,
    });
  }

  const currentDialogueInfoAction = _.get(currentDialogueInfo, "action", "");

  const showConfigureCategoriesButton =
    isEditingAllowed &&
    selectedSubjectId &&
    !_.isEmpty(gradeId) &&
    (!isScoreV2 || !_.isEmpty(selectedTerm)) &&
    isEditMode &&
    !isUsingNewGradingSetupInCourses &&
    !hideConfigureCategoriesButton;

  const disabledCategoryDropdownTooltip = getDisabledCategoryDropdownTooltip({
    skipSubjectCheck:
      isCourseBasedGradingEnabled && isUsingNewGradingSetupInCourses,
    selectedTerm,
    selectedSubjectId,
    subjectsField,
    t,
  });

  const renderButtonLabel = params => {
    const { isTerm = false } = params || {};

    const selectedOption = isTerm ? selectedTerm : selectedCategory;

    if (_.isEmpty(selectedOption) || selectedOption?.value === -1) {
      return <div className={classes.placeholder}>{t("common:select")}</div>;
    } else {
      const isDisabled = isTerm ? !isEditMode : disableCategoriesDropdown;
      const buttonLabelClass = classNames({
        [classes.buttonLabel]: true,
        [classes.disabledButtonLabel]: isDisabled,
      });

      return (
        <div className={buttonLabelClass}>{_.get(selectedOption, "label")}</div>
      );
    }
  };

  const renderCategoryDropdown = () => {
    if (!isEditMode && _.isEmpty(selectedCategory)) return null;

    const onClickCategory = e => {
      const selectedCategory = _.find(categoriesOptions, {
        key: e.key,
      }) || { value: -1 };
      updateCategory(selectedCategory);
    };

    const categoriesDropdownContainerClasses = classNames(classes.fullWidth, {
      [classes.categoriesDropdownContainerOnFocus]: disableCategoriesDropdown,
    });

    return (
      <div className={classes.labelAndButtonCon}>
        {!shouldHideCategoryLabel ? (
          labelComponent ? (
            React.cloneElement(labelComponent, {
              label: categoryLabel || t("common:category"),
              labelContainerStyle: styles.labelContainerStyle,
            })
          ) : (
            <div className="text-label-2">
              {categoryLabel || t("common:category")}
            </div>
          )
        ) : null}
        <div className={classes.iconButtonWithDropdown}>
          <ConditionalWrapper
            type={"wrapperAsElement"}
            condition={disableCategoriesDropdown && isEditMode}
            wrapper={
              <Tooltip
                tooltip={disabledCategoryDropdownTooltip}
                placement={"bottomLeft"}
                showArrow={true}
              />
            }
          >
            <div
              className={categoriesDropdownContainerClasses}
              tabIndex={disableCategoriesDropdown ? 0 : -1} //when disabled focus the div to shift the focus on setting icon
              role={disableCategoriesDropdown ? "button" : undefined}
              aria-label={
                disableCategoriesDropdown
                  ? disabledCategoryDropdownTooltip
                  : undefined
              }
            >
              <Dropdown
                overlay={
                  <DropdownMenu
                    options={categoriesOptions}
                    onClick={onClickCategory}
                    testId={testId}
                    {...categoryDropdownMenuProps}
                  />
                }
                className={classes.fullWidth}
                disabled={disableCategoriesDropdown}
              >
                {isValidElement(categoryTriggerElement) ? (
                  categoryTriggerElement
                ) : (
                  <Button
                    size="medium"
                    _legacy_variant="plain"
                    variant="neutral"
                    type="plain"
                    shouldStopPropagation={true}
                    className={classes.fullWidth}
                    disabled={disableCategoriesDropdown}
                    testId={testId}
                  >
                    {renderButtonLabel()}
                  </Button>
                )}
              </Dropdown>
            </div>
          </ConditionalWrapper>

          {showConfigureCategoriesButton ? (
            <IconButton
              size={"medium"}
              _legacy_variant={"plain"}
              type="plain"
              variant="neutral"
              onClick={handleShowModal}
              icon={<SettingsOutlined variant="subtle" />}
              className={classes.configureCategoriesIcon}
              testId={`${testId}-configure`}
            />
          ) : null}
        </div>
      </div>
    );
  };

  const renderTermsDropdown = () => {
    if (!isEditMode && _.isEmpty(selectedTerm)) return null;

    const dropdownButtonClassName = classNames({
      [classes.fullWidth]: true,
      [classes.errorBorder]: isError,
    });

    const onClickTerm = e => {
      const selectedTerm = _.find(termsOptions, { key: e.key });
      onChangeTerm(selectedTerm);
    };

    return (
      <>
        {labelComponent ? (
          React.cloneElement(labelComponent, {
            icon: "CalendarScheduleOutlined",
            label: termDropdownLabel,
            labelContainerStyle: styles.labelContainerStyle,
          })
        ) : (
          <div className="text-label-2">{termDropdownLabel}</div>
        )}
        <div className={classes.fullWidth}>
          <Dropdown
            overlay={
              <DropdownMenu
                options={termsOptions}
                onClick={onClickTerm}
                shouldStopPropagation={true}
                testId={`${testId}-term`}
              />
            }
            className={classes.fullWidth}
            disabled={!isEditMode}
          >
            <Button
              _legacy_variant="plain"
              size="medium"
              variant="neutral"
              type="plain"
              shouldStopPropagation={true}
              className={dropdownButtonClassName}
              disabled={!isEditMode}
              testId={`${testId}-term`}
            >
              {renderButtonLabel({ isTerm: true })}
            </Button>
          </Dropdown>
        </div>
      </>
    );
  };

  return (
    <div className={classes.container}>
      <div className={classes.dropdownContainer}>
        {showTermsDropdown ? (
          <div className={classes.termsDropdown}>{renderTermsDropdown()}</div>
        ) : null}

        {showCategoryDropdown ? (
          <div className={classes.categoryDropdown}>
            {renderCategoryDropdown()}
          </div>
        ) : null}

        {!_.isEmpty(currentDialogueInfoAction) ? (
          <Modal
            shouldCloseOnEsc={true}
            shouldCloseOnOverlayClick={true}
            hasOverlay={true}
            width={DIALOGS_INFO[currentDialogueInfoAction]?.width()}
            height={"max-content"}
            onClose={() => setCurrentDialogueInfo({})}
          >
            <Modal.Header
              title={DIALOGS_INFO[currentDialogueInfoAction]?.title({
                t,
                currentDialogueInfo,
              })}
            />
            <Modal.Body isScrollable={true}>
              {DIALOGS_INFO[currentDialogueInfoAction]?.body({
                t,
                currentDialogueInfo,
                setCurrentDialogueInfo,
              })}
            </Modal.Body>
            <Modal.Footer>
              <footer className={classes.footer}>
                <Button
                  _legacy_size={"large"}
                  size="medium"
                  _legacy_variant={"outlined-subtle"}
                  variant="neutral"
                  type="outlined"
                  onClick={() => setCurrentDialogueInfo({})}
                >
                  {DIALOGS_INFO[currentDialogueInfoAction]?.cancelButtonText({
                    t,
                  })}
                </Button>
                <Button
                  _legacy_size={"large"}
                  size="medium"
                  disabled={DIALOGS_INFO[
                    currentDialogueInfoAction
                  ]?.disableConfirmButton?.({
                    currentDialogueInfo,
                  })}
                  onClick={onClickConfirm}
                >
                  {DIALOGS_INFO[currentDialogueInfoAction]?.confirmButtonText({
                    t,
                    termLabel: termDropdownLabel,
                  })}
                </Button>
              </footer>
            </Modal.Footer>
          </Modal>
        ) : null}

        {showLoader ? (
          <FullScreenLoader overlayContainer={classes.overlayContainer} />
        ) : null}
      </div>

      {showConfigureCategoriesModal ? (
        <div className={classes.modalContainer}>
          <SubjectCategory
            classSettingMode={classSettingMode}
            setClassSettingMode={setClassSettingMode}
            assessmentCategoryId={assessmentCategoryId}
            isClassSettingsContext={true}
            curriculumType={curriculumType}
            editAssessmentCategoryModalTitle={editAssessmentCategoryModalTitle}
            scoreBasedAssessmentVariables={scoreBasedAssessmentVariables}
            curriculumProgramId={curriculumProgramId}
            rootNodes={rootNodes}
            subject={subject}
            isScoreV2={isScoreV2}
            containerStyle={_.get(styles, "childrenContainerStyle", {})}
            isCourseApplicableToCategorySet={isCourseApplicableToCategorySet}
            pointSetVariables={pointSetVariables}
            termId={academicTermId}
            subjectId={subjectId}
            subjectName={subjectName}
            selectedGrade={selectedGrade}
            showConfigureCategoriesModal={showConfigureCategoriesModal}
            setShowConfigureCategoriesModal={setShowConfigureCategoriesModal}
            getOrganizationPointSet={getOrganizationPointSet}
            closeConfigureCategoriesModalOnSave={
              closeConfigureCategoriesModalOnSave
            }
            alertText={t("schoolSetup:assessment_categories_alert_text", {
              course: subjectName,
            })}
            initialStateFromProps={stateForScoreCategories}
            defaultGradeScaleSet={defaultGradeScaleSet}
            portalType={portalType}
          />
        </div>
      ) : null}
    </div>
  );
});

AssessmentCategory.displayName = "AssessmentCategory";

const mapStateToProps = (state, ownProps) => {
  const {
    parentId,
    dependentFieldValue,
    mode,
    learningCourseId,
    category,
  } = ownProps;
  const paramsCourseId = _.get(ownProps, "params.course_id");

  const activeTab = state.login.activeTab;
  const isToddleLibrary = activeTab == TODDLE_LIBRARY;

  const organizationId = _.get(state, "login.userInfo.org_id");

  const selectedAcademicYearIdOnPlatformSwitcher = getSelectedAcademicYearId(
    state
  );
  const selectedAcademicYearId = isToddleLibrary
    ? _.get(getCurrentAcademicYear({ organizationId }), "id", null)
    : selectedAcademicYearIdOnPlatformSwitcher;

  const collaboratorsFilter = {
    userAcademicYearId: selectedAcademicYearIdOnPlatformSwitcher,
  };
  const assessmentDetails = getAssessmentDetailsFromCache({
    id: parentId,
    collaboratorsFilter,
  });

  const curriculumProgramId = isToddleLibrary
    ? _.get(state, "classRoom.curriculumProgram.id", "")
    : _.get(state, "platform.currentCurriculumProgram.id", null) ||
      _.get(assessmentDetails, "curriculumProgram.id");

  const curriculumType = isToddleLibrary
    ? _.get(state, "classRoom.curriculumProgram.type", "")
    : getCurrentCurriculumProgramType(state) ||
      _.get(assessmentDetails, "curriculumProgram.type");

  let selectedCourseId = _.get(
    state,
    "teacher.selected_class.selected_course",
    ""
  );

  selectedCourseId = !_.isEmpty(selectedCourseId)
    ? selectedCourseId
    : ownProps?.selectedCourseId;

  const courseId = paramsCourseId ? paramsCourseId : selectedCourseId;
  const { selectedSubjectId } = getSelectedSubjectIdMemoize({
    dependentFieldValue,
  });

  const assessmentId = _.get(ownProps, "parentId")
    ? _.get(ownProps, "parentId")
    : _.get(ownProps, "params.assessmentId");

  const { unitPlanSubjects } = getUnitPlanRelatedData({
    assessmentId,
    collaboratorsFilter,
  });
  const isTOK = _.get(unitPlanSubjects, [0, "type"]) === "TOK";

  const isCourseApplicableToCategorySet =
    checkCategorySetApplicableTo({
      organizationId,
    }) === "COURSE";

  const isCategoryDropdownEnabled =
    selectedSubjectId && (isCourseApplicableToCategorySet ? courseId : true);

  const isScoreV2 = getIsScoreV2({ curriculumType });

  const weightageTypeSettingName = getGradeCalculationWeightageTypeSetting({
    curriculumType,
  });

  const weightageType = getSettingValue({
    name: weightageTypeSettingName,
    currentCurriculumProgramId: curriculumProgramId,
  });

  const isCategoryWeightageEnabled = getSettingValue({
    name: USE_WEIGHTAGE_FOR_CATEGORY_SETTING,
    currentCurriculumProgramId: curriculumProgramId,
  });
  const categoryTotalDisplayType = getSettingValue({
    currentCurriculumProgramId: curriculumProgramId,
    name: CATEGORY_FINAL_SCORE_DISPLAY_TYPE_SETTING,
  });

  const termPointSetVariables = {
    id: organizationId,
    filters: {
      types: "GRADE_BOUNDARY",
      curriculumProgramIds: curriculumProgramId,
      associatedEntites: [
        {
          type: "SUBJECT",
          ids: selectedSubjectId,
        },
      ],
    },
  };

  const assessmentTools = _.get(assessmentDetails, "assessmentTools", []);

  const autoIBGradeTool = _.find(assessmentTools?.edges, ({ node }) => {
    const assessmentToolType = _.get(node, "assessmentToolType");

    return _.includes(
      [
        ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
        ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
      ],
      assessmentToolType
    );
  });

  const gradeScaleTool = _.find(assessmentTools?.edges, ({ node }) => {
    const assessmentToolType = _.get(node, "assessmentToolType");
    return assessmentToolType === GRADE_SCALE_TOOL;
  });

  const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

  const termsFilters = {
    curriculumProgramIds: !_.isEmpty(curriculumProgramId)
      ? [curriculumProgramId]
      : undefined,
    types: ["REPORTING", "EXAM"],
    learningCourseIds: isLearningCoursesEnabled ? learningCourseId : undefined,
  };

  const subjectFilters = getAdminSetupFiltersByEntityTypeMemoized({
    curriculumProgramId,
    type: "SUBJECT",
  });

  const permissionContext = [
    { entityId: curriculumProgramId, entityType: "CURRICULUM_PROGRAM" },
  ];
  if (courseId) {
    permissionContext.push({ entityId: courseId, entityType: "COURSE" });
  }

  const canTeacherConfigureCategories = ACLStorage.getPermissionValueByContext(
    MANAGE_ASSESSMENT_CATEGORY_PERMISSION,
    permissionContext
  );

  const isEditingAllowed = canTeacherConfigureCategories;

  const assessmentFields = _.get(ownProps, "assessmentFields");

  const currentSubjectFromProps = _.get(ownProps, "currentSubject", []);
  const currentSubjectFromAssessmentFields = _.get(
    _.get(_.find(assessmentFields, { uid: "subjects" }), "resolvedMinimalTree"),
    "subjects",
    []
  );
  const currentSubject = !_.isEmpty(currentSubjectFromAssessmentFields)
    ? currentSubjectFromAssessmentFields
    : currentSubjectFromProps;

  const academicTermId = _.get(ownProps, "academicTermId");

  const subject = _.find(
    currentSubject,
    item => item?.id === selectedSubjectId
  );
  const subjectId = _.get(subject, "id", "");
  const subjectName = _.get(subject, "name", "");
  const assessmentCategoryId = `${subjectId}${academicTermId}`;

  const scoreBasedAssessmentVariables = {
    organizationId,
    filters: subjectFilters,
    pointAssessmentFilters: { types: "SCORE" },
  };
  const rootNodes = _.filter(currentSubject, subject => {
    const subjectType = _.get(subject, "type");
    return !_.includes(getSubjectsWithNoGradebook(), subjectType);
  });

  const courseGradeFilters = {
    academicYearId: selectedAcademicYearId,
  };

  const isNewAssessmentSettingsEnabled = getIsNewAssessmentSettingsEnabled();
  const courseDetails = getCourseDetails({
    id: courseId,
    courseGradeFilters,
  });

  const isDemo = _.get(courseDetails, "isDemo", false);

  const academicSetupType = getAcademicSetupTypeIfLearningCoursesEnabled();
  const isCourseBasedGrading = academicSetupType === COURSE_BASED_GRADING;
  const isSubjectBasedGrading = academicSetupType === SUBJECT_BASED_GRADING;

  const learningCourseVariables = getLearningCourseVariables({
    learningCourseId,
    academicYearId: selectedAcademicYearId,
  });
  const learningCourse = getLearningCourseDetailsFromCache(
    learningCourseVariables
  );

  const categoryGradeId = _.chain(category)
    .get("set.associatedEntities")
    .find({ __typename: "Grade" })
    .get("id")
    .value();

  const gradeId = _.get(learningCourse, "primaryGrade.id") || categoryGradeId;

  return {
    isData: true,
    isLoading: false,
    isCategoryDropdownEnabled,
    selectedSubjectId,
    unitPlanSubjects,
    dependentFieldValue,
    courseId,
    isScoreV2,
    variables: {
      id: _.get(state, "login.userInfo.org_id"),
      filters: {
        types: "SCORE",
        curriculumProgramIds: curriculumProgramId,
        associatedEntites: [
          {
            type: "SUBJECT",
            ids: selectedSubjectId,
          },
        ],
      },
    },
    curriculumProgramId,
    organizationId,
    selectedCourseId,
    isCourseApplicableToCategorySet,
    platform: "ADMIN",
    categories: [getGradeCalculationMethodCategory({ curriculumType })],
    isTOK,
    weightageType,
    weightageTypeSettingName,
    termPointSetVariables,
    autoIBGradeTool,
    gradeScaleTool,
    portalType: "PLANNER",
    termsFilters,
    curriculumType,
    subjectFilters,
    isEditingAllowed,
    subject,
    subjectId,
    subjectName,
    assessmentId,
    assessmentCategoryId,
    scoreBasedAssessmentVariables,
    rootNodes,
    selectedAcademicYearId,
    courseGradeFilters,
    isEditMode: mode === "edit",
    isNewAssessmentSettingsEnabled,
    isDemo,
    isCourseBasedGrading,
    isSubjectBasedGrading,
    gradeId,
    isCourseBasedGradingEnabled: getIsCourseBasedGradingEnabled(),
    isLearningCoursesEnabled,
    isCategoryWeightageEnabled,
    categoryTotalDisplayType,
    selectedSubjectIds: _.compact(dependentFieldValue),
  };
};

const mapActionCreators = {
  updateAssessment,
  removeAssessmentTool,
};

const getDerivedProps = ownProps => {
  const {
    category: _category,
    globalCategories,
    curriculumProgramId,
    selectedAcademicYearId,
  } = ownProps;

  const isUsingNewGradingSetupInCourses = getIsConfigurationEnabledForCPAY({
    configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
    curriculumProgramId: curriculumProgramId,
    academicYearId: selectedAcademicYearId,
  });

  const category = getCategoryObj({
    globalCategories,
    category: _category,
    isUsingNewGradingSetupInCourses,
  });

  return {
    category,
    isUsingNewGradingSetupInCourses,
  };
};

export default compose(
  I18nHOC({ resource: ["common", "classRoom", "schoolSetup"] }),
  connect(mapStateToProps, mapActionCreators),
  withDerivedProps(getDerivedProps),
  withControlParameters({
    skip: ({ courseId }) => _.isEmpty(courseId),
    skipContextSetup: true,
    options: ({ courseId, curriculumProgramId }) => {
      return {
        variables: {
          filters: {
            module: "SUBJECT_SETTINGS",
            appType: ["TEACHER_WEB"],
            controlParameterTypes: ["PERMISSION"],
            contexts: [
              [
                {
                  entityId: curriculumProgramId,
                  entityType: "CURRICULUM_PROGRAM",
                },
                { entityId: courseId, entityType: "COURSE" },
              ],
            ],
          },
        },
      };
    },
  }),
  graphql(getOrganizationPointSetQuery, {
    name: "getOrganizationPointSet",
    skip: ({ curriculumType, isUsingNewGradingSetupInCourses }) =>
      isUsingNewGradingSetupInCourses || curriculumType !== CURRICULUM_TYPE_UBD,
    options: ({ organizationId, curriculumProgramId, portalType }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: organizationId,
        filters: {
          types: "LOCAL_GRADE",
          curriculumProgramIds: curriculumProgramId,
          subTypes: "DEFAULT",
        },
        portalType,
      },
      context: {
        useHttpLink: true,
      },
    }),
    props({
      getOrganizationPointSet: { networkStatus, variables },
      ownProps: { isData, isLoading },
    }) {
      const organizationPointSetData = getOrganizationPointSetFromCache({
        variables,
      });

      const organizationPointSet = _.get(
        organizationPointSetData,
        "pointAssessmentSets.edges",
        []
      );

      return {
        defaultGradeScaleSet: _.get(_.first(organizationPointSet), "node", {}),
        isData: !_.isEmpty(organizationPointSetData) && isData,
        isLoading: _.includes([1, 2], networkStatus) || isLoading,
      };
    },
  }),
  graphql(getOrganizationAcademicYearsQuery, {
    name: "getOrganizationAcademicYears",
    options: ({ organizationId, termsFilters, portalType }) => {
      return {
        variables: {
          id: organizationId,
          termsFilters,
          portalType,
        },
        fetchPolicy: "cache-and-network",
      };
    },
    props: ({
      getOrganizationAcademicYears,
      ownProps: {
        organizationId,
        curriculumProgramId,
        academicTermId,
        selectedAcademicYearId,
        termsFilters,
        isLoading,
        isData,
      },
    }) => {
      const data = getOrganizationAcademicYearsFromCache({
        organizationId,
        termsFilters,
      });
      const academicYearsList = _.get(data, "node.academicYears", []);

      const selectedAcademicYearTerms = _.get(
        _.find(academicYearsList, academicYear => {
          return _.isEqual(
            _.get(academicYear, "id", ""),
            selectedAcademicYearId
          );
        }),
        "terms",
        []
      );

      const isSelectedTermInCurrentAcademicYear = _.find(
        selectedAcademicYearTerms,
        term => _.get(term, "id") === academicTermId
      );

      const terms = _.filter(selectedAcademicYearTerms, term => {
        return _.isEqual(
          _.get(term, "curriculumProgram.id", ""),
          curriculumProgramId
        );
      });

      let previousAcademicYearTermSelected = false;

      if (!isSelectedTermInCurrentAcademicYear) {
        const previousAcademicYearTerms = _.flatten(
          _.map(
            _.filter(academicYearsList, academicYear => {
              return _.get(academicYear, "isPreviousAcademicYear", false);
            }),
            academicYear => _.get(academicYear, "terms")
          )
        );
        const prevAcademicYearTerm = _.find(
          previousAcademicYearTerms,
          term => _.get(term, "id") === academicTermId
        );

        if (prevAcademicYearTerm) {
          previousAcademicYearTermSelected = true;
          terms.unshift({ ...prevAcademicYearTerm, isDisabled: true });
        }
      }

      return {
        isData: !_.isEmpty(data) && isData,
        isLoading:
          getOrganizationAcademicYears["networkStatus"] == 1 ||
          getOrganizationAcademicYears["networkStatus"] == 2 ||
          isLoading,
        terms,
        previousAcademicYearTermSelected,
      };
    },
  }),
  graphql(getCourseDetailsQuery, {
    name: "getCourseDetails",
    skip: ({
      courseId,
      isAdminPage,
      isCourseApplicableToCategorySet,
      isLearningCoursesEnabled,
    }) =>
      isAdminPage ||
      isCourseApplicableToCategorySet ||
      _.isEmpty(courseId) ||
      isLearningCoursesEnabled,
    options: ({ courseId, portalType, courseGradeFilters, isDemo }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: courseId,
        portalType: !isDemo ? portalType : undefined,
        courseGradeFilters,
      },
    }),
    props: ({
      getCourseDetails,
      ownProps: { courseId, courseGradeFilters, isData, isLoading },
    }) => {
      const queryData = getCourseDetailsFromCache({
        id: courseId,
        courseGradeFilters,
      });
      const grades = _.get(queryData, "grades", []);
      return {
        gradeId:
          _.get(queryData, "primaryGrade.id", "") ||
          _.get(_.head(grades), "id", ""),
        gradeName: _.get(queryData, "primaryGrade.name", ""),
        isData: !_.isEmpty(queryData) && isData,
        isLoading:
          _.includes([1, 2], getCourseDetails.networkStatus) || isLoading,
      };
    },
  }),
  graphql(getAssessmentLearningCourseDetailsQuery, {
    name: "getAssessmentLearningCourseDetails",
    skip: ({
      learningCourseId,
      isAdminPage,
      isLearningCoursesEnabled,
      isCourseBasedGradingEnabled,
    }) =>
      isAdminPage ||
      _.isEmpty(learningCourseId) ||
      !isLearningCoursesEnabled ||
      isCourseBasedGradingEnabled,
    options: ({ learningCourseId, portalType, isDemo }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: learningCourseId,
        portalType: !isDemo ? portalType : undefined,
      },
    }),
    props: ({
      getAssessmentLearningCourseDetails,
      ownProps: { isData, isLoading },
    }) => {
      const queryData = _.get(getAssessmentLearningCourseDetails, "node", {});
      const grades = _.get(queryData, "grades", []);
      return {
        gradeId:
          _.get(queryData, "primaryGrade.id", "") ||
          _.get(_.head(grades), "id", ""),
        gradeName: _.get(queryData, "primaryGrade.name", ""),
        isData: !_.isEmpty(queryData) && isData,
        isLoading:
          _.includes(
            [1, 2],
            getAssessmentLearningCourseDetails?.networkStatus
          ) || isLoading,
      };
    },
  }),
  graphql(getOrganizationPointSetQuery, {
    name: "getOrganizationPointSet",
    skip: ({
      courseId,
      gradeId,
      isCourseApplicableToCategorySet,
      isCategoryDropdownEnabled,
      isUsingNewGradingSetupInCourses,
    }) =>
      isUsingNewGradingSetupInCourses ||
      !isCategoryDropdownEnabled ||
      (isCourseApplicableToCategorySet && _.isEmpty(courseId)) ||
      (!isCourseApplicableToCategorySet && _.isEmpty(gradeId)),
    options: ({
      variables,
      gradeId,
      isCourseApplicableToCategorySet,
      courseId,
      portalType,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        ...variables,
        portalType,
        filters: {
          ...variables.filters,
          associatedEntites: [
            ...variables.filters.associatedEntites,
            getAssociatedEntitiesVariables({
              gradeId,
              isCourseApplicableToCategorySet,
              courseId,
            }),
          ],
        },
      },
    }),
    props({
      getOrganizationPointSet,
      ownProps: {
        variables,
        gradeId,
        isCourseApplicableToCategorySet,
        courseId,
        isData,
        isLoading,
      },
    }) {
      const organizationPointSetData = getOrganizationPointSetFromCache({
        variables: {
          ...variables,
          filters: {
            ...variables.filters,
            associatedEntites: [
              ...variables.filters.associatedEntites,
              getAssociatedEntitiesVariables({
                gradeId,
                isCourseApplicableToCategorySet,
                courseId,
              }),
            ],
          },
        },
      });

      const organizationPointSet = _.get(
        organizationPointSetData,
        "pointAssessmentSets.edges",
        []
      );

      return {
        getOrganizationPointSetRefetch: getOrganizationPointSet.refetch,
        organizationPointSet,
        isData: !_.isEmpty(organizationPointSet) && isData,
        isLoading:
          _.includes([1, 2], getOrganizationPointSet.networkStatus) ||
          isLoading,
      };
    },
  }),
  graphql(getCourseGradingSettingsAndCategorySetsQuery, {
    name: "getCourseGradingSettingsAndCategorySets",
    skip: ({
      learningCourseId,
      isUsingNewGradingSetupInCourses,
      isCourseBasedGrading,
    }) =>
      !learningCourseId ||
      !isCourseBasedGrading ||
      !isUsingNewGradingSetupInCourses,
    options: ({ learningCourseId, portalType }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: learningCourseId,
        filters: {
          type: "SCORE_BASED",
        },
        portalType,
      },
    }),
    props: ({
      getCourseGradingSettingsAndCategorySets,
      ownProps: { isData, isLoading },
    }) => {
      const response = _.get(
        getCourseGradingSettingsAndCategorySets,
        "node",
        {}
      );

      const hasScoreBasedMethodology = _.includes(
        _.get(response, "gradingMethodology.gradingMethodologyTypes", []),
        SCORE_BASED
      );

      const learningCourseGradingConfig = hasScoreBasedMethodology
        ? _.find(_.get(response, "gradingConfigurations"), {
            type: SCORE_BASED,
          })
        : null;

      return {
        learningCourseGradingConfig,
        isData: !_.isEmpty(response) && isData,
        isLoading:
          getCourseGradingSettingsAndCategorySets["networkStatus"] == 1 ||
          getCourseGradingSettingsAndCategorySets["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getMultiSubjectGradingSettingsAndCategorySetsQuery, {
    name: "getMultiSubjectGradingSettingsAndCategorySets",
    skip: ({
      selectedSubjectIds,
      isCourseBasedGrading,
      gradeId,
      isUsingNewGradingSetupInCourses,
    }) =>
      !isUsingNewGradingSetupInCourses ||
      isCourseBasedGrading ||
      _.isEmpty(selectedSubjectIds) ||
      _.isEmpty(gradeId),
    options: ({
      selectedSubjectIds,
      gradeId,
      portalType,
      selectedAcademicYearId,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        ids: selectedSubjectIds,
        filters: {
          type: "SCORE_BASED",
          gradeIds: [gradeId],
        },
        gradingMethodologyFilters: {
          gradeIds: [gradeId],
          academicYearId: selectedAcademicYearId,
        },
        portalType,
      },
    }),
    props: ({
      getMultiSubjectGradingSettingsAndCategorySets,
      ownProps: { isData, isLoading },
    }) => {
      const multiSubjectGradingConfigData = _.get(
        getMultiSubjectGradingSettingsAndCategorySets,
        "multiNode",
        []
      );

      const multiSubjectGradingConfig = _.compact(
        _.map(multiSubjectGradingConfigData, item => {
          const hasScoreBasedMethodology = _.some(
            _.get(item, "gradingMethodologies", []),
            gm =>
              _.includes(_.get(gm, "gradingMethodologyTypes", []), SCORE_BASED)
          );

          if (!hasScoreBasedMethodology) return null;

          return _.find(_.get(item, "gradingConfigurations", []), {
            type: SCORE_BASED,
          });
        })
      );

      return {
        multiSubjectGradingConfig,
        isData: !_.isEmpty(multiSubjectGradingConfig) && isData,
        isLoading:
          getMultiSubjectGradingSettingsAndCategorySets["networkStatus"] == 1 ||
          getMultiSubjectGradingSettingsAndCategorySets["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  WithConfigurationsAndPreferences({
    skip: ({ organizationId }) => !organizationId,
    options: ({ organizationId }) => ({
      fetchPolicy: "cache-and-network",
      variables: generateConfigurationQueryVariablesV2({
        src: "ORGANIZATION_LEVEL",
        organizationId,
        modules: ["SUBJECT_SETTINGS"],
      }),
    }),
    getConfigurationKeys: () => ["ORGANIZATION"],
    preferences: { skip: () => true },
  })
)(AssessmentCategory);
